import { PORTAL_CTA, PORTAL_CTA_INK } from '../../../lib/portalTheme';
import PortalIcon from './PortalIcon';
import React, { useEffect, useState } from 'react';
import { ArrowLeft, ArrowRight, Brush, Globe2, Images, Megaphone, PenTool, Sparkles } from 'lucide-react';
import { PORTAL_FALLBACK_ACCENT } from '../../../lib/portalAccent';

const ICONS = {
  brush: Brush,
  sparkles: Sparkles,
  globe: Globe2,
  images: Images,
  pen: PenTool,
};

export const DEFAULT_STUDIO_NEWS_ITEMS = [
  {
    id: 'mantenimiento',
    icon: 'brush',
    tag: 'Crecimiento',
    title: 'Mantenimiento mensual de marca',
    copy: 'Acompañamiento para que tu identidad se mantenga consistente en piezas, redes y campañas.',
    cta: 'Pedir propuesta',
    tone: '#f09e9e',
    accent: '#eb6154',
    body: 'Cada identidad que sale del estudio empieza igual: escuchando. Este acompañamiento nace de ver marcas hermosas perder consistencia a los tres meses de la entrega.\n\nEl programa cubre revisiones mensuales de piezas, ajustes de aplicación y una línea directa con el equipo para resolver dudas de uso. La marca se mantiene viva sin depender de la suerte.\n\nSi tu proyecto está en curso, este servicio se activa al cerrar la entrega final.',
    imageUrl: '',
  },
  {
    id: 'lanzamiento',
    icon: 'sparkles',
    tag: 'Lanzamiento',
    title: 'Campaña de salida al mercado',
    copy: 'Estrategia visual y piezas clave para presentar tu nueva marca con dirección y claridad.',
    cta: 'Explorar campaña',
    tone: '#eb6154',
    accent: '#f09e9e',
    body: 'Lanzar una marca no es publicarla: es presentarla con dirección. Preparamos la secuencia de revelación, las piezas clave del anuncio y el tono de los primeros mensajes.\n\nEl paquete incluye estrategia de revelación, plantillas de anuncio y un calendario de primeras publicaciones pensado para tu audiencia real.\n\nDisponible como extensión de cualquier proyecto de identidad en curso.',
    imageUrl: '',
  },
  {
    id: 'digital',
    icon: 'globe',
    tag: 'Digital',
    title: 'Landing o sitio web',
    copy: 'Convierte tu identidad en una experiencia digital preparada para vender, agendar o captar leads.',
    cta: 'Quiero verlo',
    tone: '#3d3d83',
    accent: '#9b9bd7',
    imageUrl: '',
  },
  {
    id: 'contenido',
    icon: 'images',
    tag: 'Contenido',
    title: 'Sistema de plantillas para redes',
    copy: 'Un set editable para comunicar con la misma calidad visual después de la entrega del Brand Kit.',
    cta: 'Solicitar opciones',
    tone: '#f09e9e',
    accent: '#3d3d83',
    body: 'Después de la entrega del Brand Kit, la pregunta siempre es la misma: y ahora, quién diseña el día a día. Este set responde eso.\n\nPlantillas editables construidas con tu sistema visual real — tipografías, ritmos y usos correctos del color — para que cada publicación se vea del estudio sin pasar por el estudio.\n\nSe entrega configurado para tu marca, no como plantilla genérica.',
    imageUrl: '',
  },
  {
    id: 'proceso',
    icon: 'pen',
    tag: 'Estudio',
    title: 'Así escuchamos antes de diseñar',
    copy: 'Una mirada al Método Ψ: por qué cada marca de Feria empieza con una conversación, no con un moodboard.',
    cta: 'Leer la nota',
    tone: '#3d3d83',
    accent: '#eb6154',
    body: 'El Método Ψ arranca con una conversación larga antes de abrir cualquier programa de diseño. Queremos el negocio, la historia y la ambición — no referencias de Pinterest.\n\nDe esa escucha sale el brief real: el documento que gobierna cada decisión visual del proyecto. Por eso cada marca de Feria se siente inevitable para su dueño: no se parece a la moda, se parece a la empresa.\n\nEn el portal puedes ver este método en acción: tu camino del proyecto es exactamente esa secuencia.',
    imageUrl: '',
  },
  {
    id: 'brandkit-guia',
    icon: 'images',
    tag: 'Recursos',
    title: 'Saca todo el jugo a tu Brand Kit',
    copy: 'Cinco usos de tu kit que la mayoría descubre tarde: firmas, empaques, presentaciones y más.',
    cta: 'Ver la guía',
    tone: '#eb6154',
    accent: '#3d3d83',
    body: 'Tu Brand Kit trae más de lo que parece. Estos son los cinco usos que la mayoría descubre tarde.\n\nUno: firmas de correo con la tipografía correcta. Dos: portadas de propuestas y presentaciones. Tres: etiquetas y empaques de bajo tiraje. Cuatro: fondos y avatares coherentes en cada red. Cinco: documentos internos que también hablan tu marca.\n\nTodo está en los archivos que ya tienes. Si algo no aparece, escríbenos por el chat del portal.',
    imageUrl: '',
  },
  {
    id: 'caso-cafe',
    icon: 'brush',
    tag: 'Casos',
    title: 'Una marca que huele a café de origen',
    copy: 'El detrás de cámaras de una identidad nacida en la montaña ecuatoriana.',
    cta: 'Ver el caso',
    tone: '#f09e9e',
    accent: '#eb6154',
    body: 'Una finca familiar en la montaña ecuatoriana, tres generaciones de café y ninguna marca que lo contara. Ese fue el punto de partida.\n\nLa identidad nació del paisaje real: los verdes se descartaron pronto — el protagonista era el atardecer sobre el secadero, y de ahí salió la paleta cálida que hoy firma cada empaque.\n\nEl resultado: un café que en góndola se ve exactamente como sabe.',
    imageUrl: '',
  },
  {
    id: 'imprenta',
    icon: 'sparkles',
    tag: 'Noticias',
    title: 'Nueva alianza de impresión premium',
    copy: 'Tus piezas físicas ahora salen con acabados de galería: stamping, relieves y papeles de algodón.',
    cta: 'Conocer más',
    tone: '#9b9bd7',
    accent: '#3d3d83',
    body: 'Cerramos una alianza con un taller de impresión premium: stamping metálico, relieves secos y papeles de algodón de archivo.\n\nPara los proyectos en curso significa una cosa concreta: tus piezas físicas — tarjetas, empaques, papelería — pueden salir con acabados de galería sin gestionar proveedores por tu cuenta.\n\nPídenos muestras por el chat del portal y las llevamos a tu próxima reunión.',
    imageUrl: '',
  },
];

function normalizeNewsItems(items) {
  const source = Array.isArray(items) && items.length ? items : DEFAULT_STUDIO_NEWS_ITEMS;
  return source.map((item, index) => ({
    ...DEFAULT_STUDIO_NEWS_ITEMS[index % DEFAULT_STUDIO_NEWS_ITEMS.length],
    ...item,
    id: item.id || `news-${index}`,
    icon: item.icon || 'sparkles',
    tone: item.tone || '#eb6154',
    accent: item.accent || '#f09e9e',
    imageUrl: item.imageUrl || '',
  }));
}

function VisualPanel({ item, isDark, compact = false, hero = false }) {
  const Icon = ICONS[item.icon] || PenTool;
  const paper = isDark ? '#232323' : '#f5f5f5';
  const ink = isDark ? '#F5F5F4' : '#171717';
  const line = isDark ? 'rgba(255,255,255,.18)' : 'rgba(23,23,23,.18)';
  // Misma regla que el editor de Novedades y que el carrusel del Home: el HERO —la vista
  // grande de la novedad abierta— usa la foto de BANNER; las tarjetas usan la PORTADA.
  // Y cada una con SU punto focal, que el staff arrastra en Admin sobre una preview que
  // dice ser fiel. Este render era el TERCER `center / cover` quemado: lo encontro el
  // barrido P0 de cierre, DESPUES de dar por arreglado el hallazgo. Un archivo que la
  // prueba no miraba no estaba cubierto.
  const imageUrl = String((hero ? item.bannerImageUrl : item.imageUrl) || item.imageUrl || '').trim();
  const imagePosition = (hero ? item.bannerImagePosition : item.imagePosition) || '50% 50%';
  return (
    <div className={`studio-news-visual ${hero ? 'studio-news-visual-hero' : ''} ${compact ? 'studio-news-visual-compact' : ''}`} style={{
      height: compact ? 132 : '100%',
      minHeight: compact ? 132 : hero ? 320 : 240,
      maxHeight: compact ? 132 : 'none',
      width: '100%',
      borderRadius: hero ? 0 : compact ? '18px 18px 0 0' : 20,
      border: hero || compact ? 'none' : `1px solid ${isDark ? 'rgba(255,255,255,.08)' : 'rgba(24,24,27,.10)'}`,
      background: imageUrl
        ? `linear-gradient(0deg, rgba(12,10,9,.28), rgba(12,10,9,.08)), url("${imageUrl}") ${imagePosition} / cover no-repeat`
        : `radial-gradient(circle at 76% 16%, ${item.accent}24, transparent 36%), linear-gradient(145deg, ${paper}, ${isDark ? '#121212' : '#e9e9e9'})`,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: hero || compact ? 'none' : isDark ? 'none' : '0 18px 45px rgba(23,23,23,.08)',
    }}>
      {!imageUrl && (
        <>
          <div style={{ position:'absolute', inset: compact ? 18 : 28, border:`2px solid ${line}`, borderRadius: compact ? 12 : 18 }} />
          <div style={{ position:'absolute', left: compact ? 22 : 38, top: compact ? 22 : 36, width: compact ? 64 : 116, height: compact ? 8 : 12, borderRadius: 20, background: item.tone }} />
          <div style={{ position:'absolute', left: compact ? 22 : 38, top: compact ? 38 : 58, width: compact ? 92 : 160, height: compact ? 6 : 9, borderRadius: 20, background: `${item.accent}AA` }} />
          <div style={{ position:'absolute', left: compact ? 22 : 38, bottom: compact ? 22 : 40, width: compact ? 76 : 118, height: compact ? 5 : 7, borderRadius: 20, background: line }} />
          <div style={{ width: compact ? 48 : 80, height: compact ? 48 : 80, borderRadius: compact ? 16 : 24, background: `${item.tone}18`, border:`1px solid ${item.tone}44`, color: item.tone, display:'grid', placeItems:'center', zIndex: 1 }}>
            <Icon size={compact ? 22 : 34} strokeWidth={1.5} />
          </div>
          <span style={{ position:'absolute', left: compact ? 26 : 44, bottom: compact ? 40 : 64, color: ink, fontFamily:"var(--font-ui, 'Inter', sans-serif)", fontSize: compact ? 17 : 24, fontWeight: 600, lineHeight:1.08 }}>
            {item.tag}
          </span>
        </>
      )}
      <div style={{ position:'absolute', right: compact ? 24 : 42, bottom: compact ? 20 : 38, color: imageUrl ? '#fff' : item.tone, fontWeight: 600, fontSize: compact ? 10 : 15, letterSpacing: '.08em', textShadow: imageUrl ? '0 2px 10px rgba(0,0,0,.35)' : 'none' }}>ESTUDIO</div>
    </div>
  );
}

export default function ClientPortalStudioNews({ isDark, accentColor = PORTAL_FALLBACK_ACCENT, onRequest, items }) {
  const [active, setActive] = useState(0);
  const [newsItems, setNewsItems] = useState(() => normalizeNewsItems(items));
  const gold = accentColor || PORTAL_FALLBACK_ACCENT;
  const text = isDark ? '#F4F4F5' : '#18181B';
  const muted = isDark ? '#A1A1AA' : '#71717A';
  const subtle = isDark ? 'rgba(244,244,245,.48)' : 'rgba(24,24,27,.48)';
  const card = isDark ? '#141416' : '#FFFFFF';
  const border = isDark ? 'rgba(255,255,255,.09)' : 'rgba(24,24,27,.10)';
  const slide = newsItems[active] || newsItems[0] || DEFAULT_STUDIO_NEWS_ITEMS[0];

  useEffect(() => {
    if (items) setNewsItems(normalizeNewsItems(items));
  }, [items]);

  useEffect(() => {
    if (newsItems.length < 2) return undefined;
    const timer = window.setInterval(() => {
      setActive(current => (current + 1) % newsItems.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [newsItems.length]);

  const next = () => setActive((active + 1) % newsItems.length);
  const prev = () => setActive((active - 1 + newsItems.length) % newsItems.length);

  return (
    <div style={{ padding: '28px 24px 36px' }}>
      <div style={{ maxWidth: 940, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', justifyContent:'space-between', marginBottom: 22, flexWrap:'wrap' }}>
          <div style={{ display:'flex', gap:14, alignItems:'flex-start' }}>
            <div style={{ width: 42, height: 42, borderRadius: 16, background: `${gold}14`, color: gold, display: 'grid', placeItems: 'center', flexShrink: 0 }}>
              <Megaphone size={20} strokeWidth={1.5} />
            </div>
            <div>
              <div style={{ fontFamily: "var(--font-ui, 'Inter', sans-serif)", fontSize: 24, fontWeight: 600, lineHeight: 1.12, color: text }}>
                Novedades del <em style={{ color: gold }}>estudio</em>
              </div>
              <div style={{ fontSize: 12, color: muted, lineHeight: 1.7, maxWidth: 560, marginTop: 8 }}>
                Ideas, servicios y recursos para extender el valor de tu marca cuando tenga sentido para tu siguiente etapa.
              </div>
            </div>
          </div>
          <div style={{ display:'inline-flex', alignItems:'center', gap:8 }}>
            {[ArrowLeft, ArrowRight].map((Control, idx) => (
              <button key={idx ? 'next' : 'prev'} type="button" onClick={idx ? next : prev} style={{ width:38, height:38, borderRadius:12, border:`1px solid ${border}`, background:card, color:text, display:'grid', placeItems:'center', cursor:'pointer' }}>
                <Control size={16} strokeWidth={1.5} />
              </button>
            ))}
          </div>
        </div>

        <section className="studio-news-hero" style={{
          display:'grid',
          gridTemplateColumns:'minmax(0, .95fr) minmax(300px, 1fr)',
          gap:0,
          alignItems:'stretch',
          background: card,
          border:`1px solid ${border}`,
          borderRadius: 22,
          padding: 0,
          marginBottom: 18,
          overflow: 'hidden',
        }}>
          <VisualPanel item={slide} isDark={isDark} hero />
          <div className="studio-news-hero-copy" style={{ display:'flex', flexDirection:'column', justifyContent:'center', padding:'clamp(20px, 4vw, 42px)' }}>
            <div style={{ display:'inline-flex', alignItems:'center', gap:8, alignSelf:'flex-start', color: slide.tone, background:`${slide.tone}12`, border:`1px solid ${slide.tone}35`, borderRadius:999, padding:'6px 11px', fontSize:11, fontWeight: 600, marginBottom:16 }}>
              <Sparkles size={13} strokeWidth={1.5} /> {slide.tag}
            </div>
            <div style={{ fontFamily:"var(--font-ui, 'Inter', sans-serif)", fontSize:'clamp(24px, 3.2vw, 34px)', fontWeight: 600, lineHeight:1.12, color:text, marginBottom:12 }}>
              {slide.title}
            </div>
            <div style={{ color: muted, fontSize:13, lineHeight:1.75, maxWidth:440 }}>
              {slide.copy}
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:10, marginTop:22, flexWrap:'wrap' }}>
              <button type="button" onClick={() => onRequest?.(slide)} style={{ background: PORTAL_CTA, color: PORTAL_CTA_INK, border:'none', borderRadius:12, padding:'11px 15px', fontSize:12, fontWeight: 600, cursor:'pointer', fontFamily:'inherit', display:'inline-flex', alignItems:'center', gap:8 }}>
                {slide.cta} <PortalIcon name="arrow" size={14} strokeWidth={1.5} />
              </button>
              <div style={{ display:'inline-flex', gap:6 }}>
                {newsItems.map((item, idx) => (
                  // impeccable-disable layout-transition — indicador de paginación: dot de 8px que crece a 22px en un click discreto; micro-animación acotada, sin layout-thrash real. transform/scaleX distorsiona el pill y rompe el espaciado; se conserva a propósito.
                  <button key={item.id} type="button" onClick={() => setActive(idx)} aria-label={`Ver ${item.title}`} style={{ width: idx === active ? 22 : 8, height:8, borderRadius:999, border:'none', background: idx === active ? gold : subtle, cursor:'pointer', transition:'width .2s' }} />
                ))}
              </div>
            </div>
          </div>
        </section>
        <style>{`
          @media (max-width: 720px){
            .studio-news-hero{grid-template-columns:1fr!important}
            .studio-news-visual-hero{min-height:220px!important;height:220px!important;border-radius:0!important}
            .studio-news-hero-copy{padding:22px!important}
          }
          @media (max-width: 420px){
            .studio-news-visual-hero{min-height:196px!important;height:196px!important}
          }
        `}</style>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: 12 }}>
          {newsItems.map((item, idx) => (
            <div key={item.id} onClick={() => setActive(idx)} style={{ background: card, border: `1px solid ${idx === active ? gold : border}`, borderRadius: 20, padding: 0, overflow: 'hidden', cursor: 'pointer' }}>
              <VisualPanel item={item} isDark={isDark} compact />
              <div style={{ padding:'14px 4px 2px' }}>
                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: item.tone, background: `${item.tone}12`, border: `1px solid ${item.tone}35`, borderRadius: 999, padding: '4px 9px', fontSize: 10, fontWeight: 600, marginBottom: 12 }}>
                  <Sparkles size={12} strokeWidth={1.5} /> {item.tag}
                </div>
                <div style={{ fontSize: 15, fontWeight: 600, color: text, marginBottom: 7 }}>{item.title}</div>
                <div style={{ fontSize: 11, color: muted, lineHeight: 1.6, minHeight: 54 }}>{item.copy}</div>
                <button type="button" onClick={(event) => { event.stopPropagation(); onRequest?.(item); }} style={{ marginTop: 14, background: 'transparent', border: `1px solid ${border}`, color: text, borderRadius: 10, padding: '9px 12px', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit', display: 'inline-flex', alignItems: 'center', gap: 7 }}>
                  {item.cta} <PortalIcon name="arrow" size={13} strokeWidth={1.5} />
                </button>
              </div>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
}
